import React from 'react';
import { ADVOCATE_ACCESS_TYPE, ADVOCATE_RESOURCE_TYPE } from './advocate-pemissions';
import { useAdvocateAccessControl } from './hooks/use-advocate-access-control';

export type AdvocateAccessWallProps = {
  accessType: ADVOCATE_ACCESS_TYPE;
  resource: ADVOCATE_RESOURCE_TYPE;
  renderNoAccess?: () => React.ReactElement;
};
export const AdvocateAccessWall: React.FC<AdvocateAccessWallProps> = ({
  children,
  accessType,
  resource,
  renderNoAccess,
}) => {
  const doesAdvocateHasPermission = useAdvocateAccessControl({
    accessType,
    resource,
  });
  if (!doesAdvocateHasPermission) {
    // If a custom no-access component is provided, render it
    if (renderNoAccess) {
      return renderNoAccess();
    }
    // If no custom no-access component is provided, render nothing
    return null;
  }
  return <>{children}</>;
};
